module.exports = __webpack_public_path__ + "static/img/1.138e9421.jpg";